function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.0765 9.00003C45.2993 8.99792 45.5152 9.10184 45.6518 9.28848L54.6588 21.5939C54.7168 21.6731 54.7576 21.7635 54.7786 21.8594L59.1367 41.7702C59.2003 42.0607 59.0745 42.36 58.8225 42.5179L45.4574 50.8925C45.3405 50.9657 45.2082 51.0012 45.0765 51C44.9448 51.0012 44.8124 50.9657 44.6956 50.8925L31.3305 42.5179C31.0785 42.36 30.9527 42.0607 31.0163 41.7702L35.3744 21.8594C35.3954 21.7635 35.4362 21.6731 35.4942 21.5939L44.5012 9.28848C44.6378 9.10184 44.8537 8.99792 45.0765 9.00003ZM44.3651 11.8602L36.8427 22.1373L38.7361 28.0832L44.3651 18.1496V11.8602ZM45.0765 19.7526L39.3188 29.9132L42.9181 41.2162H47.2349L50.8342 29.9132L45.0765 19.7526ZM51.781 31.5841L48.7138 41.2162H57.2392L51.781 31.5841ZM55.9969 42.6254H48.2651L46.3378 48.6778L55.9969 42.6254ZM45.0765 47.9945L46.7862 42.6254H43.3668L45.0765 47.9945ZM41.4392 41.2162L38.372 31.5841L32.9138 41.2162H41.4392ZM33.3895 37.5183L37.7892 29.7541L36.189 24.7286L33.3895 37.5183ZM34.1561 42.6254H41.8879L43.8152 48.6778L34.1561 42.6254ZM56.7635 37.5183L52.3638 29.7541L53.964 24.7286L56.7635 37.5183ZM53.3103 22.1373L51.4169 28.0832L45.7879 18.1496V11.8602L53.3103 22.1373Z",
  fill: "white"
});

var SvgEos = function SvgEos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EOS.4b747bad.svg";
export { ForwardRef as ReactComponent };